$('.membership__tab').on('click', function (e) {
  e.preventDefault();
  var $tabitem = $($(this).attr('href'));
  var $tabimage = $($(this).attr('href') + '--image');
  $('.membership__tab.active, .membership__image.active').removeClass('active');
  $('.membership__type--block.active').removeClass('active');
  $tabitem.addClass('active');
  $tabimage.addClass('active');
  $(this).addClass('active');
  if ($($tabitem).hasClass('active')) {
    //alert($tabitem);
    //$($tabitem).addClass('show-image');
  }

  //$('.membership__img-container').addClass($tabitem);
});
